import { cva } from '@/styled-system/css';
import { shimmerStyles } from '@zg-rentals/loading-components';

export type BoneTypes = 'bar' | 'line' | 'box' | 'badge' | 'cover';

export const boneStyles = cva({
  base: {
    ...shimmerStyles,
  },
  variants: {
    type: {
      bar: {
        height: '1200',
        width: '100%',
      },
      line: {
        height: '400',
        width: '100%',
      },
      box: {
        height: '200px',
        width: '300px',
      },
      badge: {
        height: '600',
        width: '90px',
      },
      cover: {
        height: '100%',
        width: '100%',
      },
    },
  },
});
